import Axios from '../axios-instance';

const MaterialsRequiresAPI = {
  getMaterialsRequires: body => {
    return Axios.post(`/MaterialsRequires/Get`, body).then(({ data }) => data);
  },

  delete: body => {
    return Axios.post(`/MaterialsRequires/delete`, body).then(({ data }) => data);
  },

  
  getMaterials: () => {
    return Axios.get('/MaterialsRequires/getMaterials').then(({data}) => data);
  },
  

  getMaterial: body => {
    return Axios.post(`/MaterialsRequires/getMaterial`, body).then(({ data }) => data);
  },

  insert: body => {
    return Axios.post(`/MaterialsRequires/insert`, body).then(({ data }) => data);
  },

};


export default MaterialsRequiresAPI;
